export const GROUPS_CACHE = "split-it-groups";
export const SESSION_HEADER = "Session-ID";
export const CACHED_AT_HEADER = "X-Split-It-Cached-At";
export const NETWORK_TIMEOUT_SECONDS = 3;

const SESSION_PARAM = "split-it-session";

const trimSlashes = (path) => path.replace(/\/+$/, "");

export const isGroupsRead = (url, method, apiBase) => {
  if (method !== "GET" || url.origin !== apiBase.origin) return false;
  const base = trimSlashes(apiBase.pathname);
  if (!url.pathname.startsWith(`${base}/`)) return false;
  return /^\/groups(\/\d+)?\/?$/.test(url.pathname.slice(base.length));
};

// Session-ID travels in a header, which the Cache API ignores; without it in
// the key one session could read another session's groups.
export const sessionCacheKey = (url, sessionId) => {
  const key = new URL(url);
  key.searchParams.set(SESSION_PARAM, sessionId || "");
  return key.href;
};

export const sessionOfCacheKey = (url) =>
  new URL(url).searchParams.get(SESSION_PARAM);
